import React from 'react';
import { prop } from 'ramda';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import useStatusActions from '../hooks/useStatusActions';
import { Glasses } from './icons';

const StatusActions = ({ item, draftLabel, reviewLabel, reFetchOffer }) => {
  const version = prop('version', item);
  const {
    canSendToDraft,
    canSendToReview,
    updateStatus,
    isLoading
  } = useStatusActions({ version, reFetchOffer });

  if (canSendToReview) {
    return (
      <Button
        size="large"
        className="block"
        type="primary"
        loading={isLoading}
        onClick={updateStatus('review')}
        icon={<Glasses />}
      >
        {reviewLabel}
      </Button>
    );
  }

  if (canSendToDraft) {
    return (
      <Button
        size="large"
        type="primary"
        loading={isLoading}
        onClick={updateStatus('draft')}
        icon={<EditOutlined className="hover:text-flexi-grey" />}
      >
        {draftLabel}
      </Button>
    );
  }

  return null;
};

const WrapperStatusAction = (props) => {
  const { item, userCanValidate, userIsOfferEditor } = props;
  if (!item || (!userCanValidate && !userIsOfferEditor)) {
    return null;
  }

  return <StatusActions {...props}/>;
};

export default WrapperStatusAction;
